import { render, staticRenderFns } from "./CabinConfigActive.vue?vue&type=template&id=7ef6d67c"
import script from "./CabinConfigActive.vue?vue&type=script&lang=js"
export * from "./CabinConfigActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports